import { render, staticRenderFns } from "./assessments-table.vue?vue&type=template&id=0aabeb71&"
import script from "./assessments-table.vue?vue&type=script&lang=js&"
export * from "./assessments-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports